import React, { memo } from 'react'

import { CloseIcon } from './Icons'
import { ModalWrapper, ModalHeader, ModalBody, ModalFooter, PrimaryButton, GhostButton } from './ui'

/**
 * Casca padrão dos modais do admin.
 *
 * Antes cada tela montava o próprio cabeçalho (`Flex bg='grey100'` com um
 * `CloseIcon` solto) e o botão de salvar ficava perdido no fim do formulário.
 * O modal de detalhe de solicitação já usava o visual novo — este componente
 * extrai aquele layout para que todos os modais fiquem iguais:
 *
 *   cabeçalho fixo → conteúdo rolável → rodapé fixo com as ações
 *
 * Uso:
 *
 *   <FormModal
 *     title='Nova Especialidade'
 *     onRequestClose={onRequestClose}
 *     onSubmit={handleSubmit}
 *     submitting={isSubmitting}
 *   >
 *     ...campos...
 *   </FormModal>
 */
const FormModal = ({
  title,
  children,
  onRequestClose,
  onSubmit,
  submitting = false,
  submitLabel = 'Salvar',
  cancelLabel = 'Cancelar',
  hideFooter = false,
  error = null,
}) => {
  const conteudo = (
    <>
      <ModalHeader title={title} onRequestClose={onRequestClose} closeIcon={<CloseIcon />} />
      <ModalBody>
        {/* Erro da API aparece dentro do modal: antes a operação falhava em
            silêncio e o modal fechava como se tivesse dado certo. */}
        {error && (
          <div style={{
            marginBottom: 16, padding: '10px 14px', borderRadius: 8,
            background: '#fdeaea', color: '#b3261e', fontSize: 13,
          }}>
            {error}
          </div>
        )}
        {children}
      </ModalBody>
      {!hideFooter && (
        <ModalFooter>
          <GhostButton type='button' onClick={onRequestClose} disabled={submitting}>
            {cancelLabel}
          </GhostButton>
          <PrimaryButton type='submit' disabled={submitting}>
            {submitting ? 'Salvando...' : submitLabel}
          </PrimaryButton>
        </ModalFooter>
      )}
    </>
  )

  // Com `onSubmit`, o modal inteiro vira o form: assim o Enter em qualquer
  // campo envia e o botão do rodapé continua sendo do tipo submit.
  if (onSubmit) {
    return (
      <ModalWrapper as='form' autoComplete='nope' onSubmit={onSubmit}>
        {conteudo}
      </ModalWrapper>
    )
  }

  return <ModalWrapper>{conteudo}</ModalWrapper>
}

export default memo(FormModal)
